export const legalInfosType = [
  { label: "Mention Légales", value: "mentions" },
  { label: "Conditions Générales de Vente (CGV)", value: "cgv" },
  {
    label: "Politique de protection des données personnelles®",
    value: "politique",
  },
];
